const $ = window.jQuery;

export default class Media {
  constructor(small = 576, medium = 768, large = 992, huge = 1200) {
    this.resizeTimeout = null;
    this.breakpointMap = new Map([
      ['small', small],
      ['medium', medium],
      ['large', large],
      ['huge', huge],
    ]);

    this.checkCurrentSize();
    window.addEventListener('resize', this.checkOnResize.bind(this));
  }

  checkCurrentSize() {
    this.breakpointMap.forEach((value, key) => {
      if ($(window).width() >= value) {
        this[key] = true;
      } else {
        this[key] = false;
      }
    });
  }

  checkOnResize() {
    const mediaResizedEvent = new Event('media.resized');

    window.clearTimeout(this.resizeTimeout);
    this.resizeTimeout = window.setTimeout(() => {
      this.checkCurrentSize.bind(this);
      window.dispatchEvent(mediaResizedEvent);
    }, 100);
  }
}
